import React, { createContext, useEffect, useState } from "react";
import Watch from ".";

export const WatchContex = createContext<any>(null);
const WatchGame = () => {
  const [participants, setParticipants] = useState([]);
  const [adsDetails, setAdDetails] = useState(null as any);
  const [isWatchAdd, setIsWatchAdd] = useState(false);
  const handleChange = () => {
    setIsWatchAdd(true);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <WatchContex.Provider
      value={{
        participants,
        setParticipants,
        adsDetails,
        setAdDetails,
        handleChange,
        isWatchAdd,
      }}
    >
      <Watch />
    </WatchContex.Provider>
  );
};
export default WatchGame;
